(function ($) {
	'use strict';


	var staffInfo = $('.board .info');


	function getMaxHeight(element) {
		var maxHeight = 0;

		element.each(function () {
			maxHeight = Math.max(maxHeight, $(this).innerHeight());
		});

		return maxHeight;
	}


	function setMaxHeight(height, element) {
		element.css({
			'height': height
		});
	}


	$(document).ready(function () {
		setMaxHeight( getMaxHeight(staffInfo), staffInfo );
	});


	$(window).resize(function () {
		setMaxHeight( 'auto', staffInfo );
		setMaxHeight( getMaxHeight(staffInfo), staffInfo );
	});
})(jQuery);
